import React from "react";
import "./AddressListModal.css";

const AddressListModal = ({
    isOpen,
    onClose,
    addresses,
    onAddAddress,
    onDeleteAddress,
    onMakePrimary,
}) => {
    if (!isOpen) return null;

    return (
        <div className="am-overlay">
            <div className="am-container">

                {/* Header */}
                <div className="am-header">
                    <h2>Address List</h2>
                    <button className="am-add-btn" onClick={onAddAddress}>+</button>
                </div>

                {/* Body */}
                <div className="am-body">
                    {addresses.map((address) => (
                        <div
                            key={address.address_id}
                            className={`am-card ${address.is_default ? "primary" : ""}`}
                        >
                            <div className="am-left">
                                {/* Address Text */}
                                <div className="am-address-text">
                                    {address.address_line1}<br />
                                    {address.address_line2} {address.city}<br />
                                    {address.landmark}<br />
                                    {address.state} {address.pincode}
                                </div>
                            </div>

                            {/* Right actions column */}
                            <div className="am-actions-column">
                                {/* TOP action */}
                                {address.is_default ? (
                                    <span className="am-primary-badge">Primary</span>
                                ) : (
                                    <button
                                        className="am-make-primary"
                                        onClick={() => onMakePrimary(address.address_id)}
                                    >
                                        Make Primary
                                    </button>
                                )}

                                {/* BOTTOM action */}
                                <button
                                    className="am-delete"
                                    onClick={() => onDeleteAddress(address.address_id)}
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Footer */}
                <div className="am-footer">
                    <button className="am-close-btn" onClick={onClose}>
                        Close
                    </button>
                </div>

            </div>
        </div >
    );
};

export default AddressListModal;
